import { FormlyFieldConfig } from 'ng-formly';
export const menuitemFields = [
    {
        className: 'col-md-4',
        key: 'accesslevel',
        type: 'select-component',
        defaultValue: 'tenant',
        templateOptions: {
            options: [{
                label: 'App',
                value: 'app'
            }, {
                label: 'Tenant',
                value: 'tenant'
            }],
            label: 'Access Level'
        }
    },
    {
        className: 'col-md-12',
        template: '<br><hr>',
    },
    {
        className: 'col-md-1',
        key: 'index',
        type: 'input-field',
        templateOptions: {
            type: 'number',
            placeholder: '',
            required: true,
            label: 'Index'
        }
    },
    {
        className: 'col-md-3',
        type: 'input-field',
        key: 'label',
        templateOptions: {
            type: 'text',
            label: 'Label',
            required: true,
        },
    },
    // {
    //     className: 'col-md-1',
    //     type: 'input-field',
    //     key: 'icon',
    //     templateOptions: {
    //         type: 'text',
    //         label: 'Icon',
    //         required: false,
    //     },
    // },
    {
        className: 'col-md-2',
        key: 'linktype',
        type: 'select-component',
        defaultValue: 'pagelayout',
        templateOptions: {
            options: [{
                label: 'Page Layout',
                value: 'pagelayout'
            }, {
                label: 'Direct Link',
                value: 'directlink'
            }],
            placeholder: '',
            label: 'Link Type'
        }
    },
    {
        className: 'col-md-3',
        key: 'pagelayout',
        type: 'select-component',
        templateOptions: {
            type: 'entitypagelayout',
            placeholder: '',
            required: false,
            label: 'Page Layout'
        },
        expressionProperties: {
            'templateOptions.disabled': 'model.linktype !== "pagelayout"'
        }
    },
    {
        className: 'col-md-3',
        key: 'link',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Direct Link'
        },
        expressionProperties: {
            'templateOptions.disabled': 'model.linktype !== "directlink"'
        }
    },
    {
        className: 'col-md-12',
        type: 'repeatedsection',
        key: 'submenu',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Sub Menu Items'
            },
            fieldGroup: [
                {
                    className: 'col-md-1',
                    key: 'index',
                    type: 'input-field',
                    templateOptions: {
                        type: 'number',
                        placeholder: '',
                        required: true,
                        label: 'Index'
                    }
                },
                {
                    className: 'col-md-3',
                    type: 'input-field',
                    key: 'label',
                    templateOptions: {
                        type: 'text',
                        label: 'Label',
                        required: true,
                    },
                },
                {
                    className: 'col-md-2',
                    key: 'linktype',
                    type: 'select-component',
                    defaultValue: 'pagelayout',
                    templateOptions: {
                        options: [{
                            label: 'Page Layout',
                            value: 'pagelayout'
                        }, {
                            label: 'Direct Link',
                            value: 'directlink'
                        }],
                        placeholder: '',
                        label: 'Link Type'
                    }
                },
                {
                    className: 'col-md-3',
                    key: 'pagelayout',
                    type: 'select-component',
                    templateOptions: {
                        type: 'entitypagelayout',
                        placeholder: '',
                        required: false,
                        label: 'Page Layout'
                    },
                    expressionProperties: {
                        'templateOptions.disabled': 'model.linktype !== "pagelayout"'
                    }
                },
                {
                    className: 'col-md-3',
                    key: 'link',
                    type: 'input-field',
                    templateOptions: {
                        type: 'text',
                        placeholder: '',
                        required: false,
                        label: 'Direct Link'
                    },
                    expressionProperties: {
                        'templateOptions.disabled': 'model.linktype !== "directlink"'
                    }
                }
            ]
        }
    }
];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/menuitem.ts